import type { IconProps } from '../../types';

export const CloseIcon = ({
  className,
  color = 'currentColor',
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M13.3283 12.0025L17.7261 7.59975C18.0913 7.23452 18.0913 6.63915 17.7261 6.27392C17.3609 5.90869 16.7655 5.90869 16.4003 6.27392L12.0025 10.6717L7.59975 6.27392C7.23452 5.90869 6.63915 5.90869 6.27392 6.27392C5.90869 6.63915 5.90869 7.23452 6.27392 7.59975L10.6717 11.9975L6.27392 16.4003C5.90869 16.7655 5.90869 17.3609 6.27392 17.7261C6.44903 17.9012 6.68918 18.0063 6.92933 18.0063C7.16948 18.0063 7.40963 17.9162 7.58474 17.7261L11.9975 13.3283L16.3952 17.7261C16.5704 17.9012 16.8105 18.0063 17.0507 18.0063C17.2908 18.0063 17.531 17.9162 17.7061 17.7261C18.0713 17.3609 18.0713 16.7655 17.7061 16.4003L13.3183 12.0025H13.3283Z'
        fill={color}
      />
    </svg>
  );
};

export default CloseIcon;
